import QuestionnaireStore from './QuestionnaireStore'

export default new QuestionnaireStore()
